import { render, staticRenderFns } from "./BankDetailsStep.vue?vue&type=template&id=71a05d3c&scoped=true"
import script from "./BankDetailsStep.vue?vue&type=script&lang=js"
export * from "./BankDetailsStep.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsStep.vue?vue&type=style&index=0&id=71a05d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a05d3c",
  null
  
)

export default component.exports